export enum PageLayout {
     Authorized = 'authorized',
     UnAuthorized = 'login',
     Login = 'login',
}
